import { VaultMediaType } from '@api'

import { OverlayIconsTypes } from '@/modules/vault/types.ts'

export function isStreamable(
  item?: Nullable<{ type?: VaultMediaType; full?: string }>,
) {
  return (
    !!item?.type &&
    ([VaultMediaType.AUDIO, VaultMediaType.VIDEO, VaultMediaType.GIF].includes(
      item.type,
    ) ||
      !!item.full?.includes('.mp4'))
  )
}

export function calculateImageSize(
  originalWidth: number,
  originalHeight: number,
  maxImageWidth: number,
  maxImageHeight: number,
) {
  const minHeight = 200

  if (originalHeight > maxImageHeight) {
    const aspectRatio = originalWidth / originalHeight
    const newHeight = maxImageHeight < minHeight ? minHeight : maxImageHeight
    const newWidth = newHeight * aspectRatio

    if (originalWidth <= originalHeight) {
      return {
        width: newWidth,
        height: newHeight,
      }
    }
  }

  if (originalWidth > originalHeight) {
    const maxWidth = maxImageWidth
    const minWidth = 200

    if (originalWidth > maxImageWidth) {
      const aspectRatio = originalHeight / originalWidth
      const newWidth = maxWidth < minWidth ? minWidth : maxWidth
      const newHeight = newWidth * aspectRatio

      return {
        width: newWidth,
        height: newHeight,
      }
    }
  }

  return {
    width: originalWidth,
    height: originalHeight,
  }
}

export function getOverlaySettings(
  isPosted: boolean,
  isPurchased: boolean,
  isFree: boolean,
  isMessagesOfMedia: boolean,
): {
  bgColor: string
  tagColor: string
  text: string
  iconType: OverlayIconsTypes
} | null {
  if (isPosted) {
    return {
      bgColor: '#FF903F3D',
      tagColor: 'rgba(255, 144, 63, 0.50)',
      text: 'Posted',
      iconType: OverlayIconsTypes.posted,
    }
  }

  if (isPurchased) {
    return {
      bgColor: '#0A7723',
      tagColor: 'rgba(10, 119, 35, 0.50)',
      text: 'Bought',
      iconType: OverlayIconsTypes.bought,
    }
  }

  if (isFree) {
    return {
      bgColor: '#9601CA3D',
      tagColor: 'rgba(150, 1, 202, 0.50)',
      text: 'Sent',
      iconType: OverlayIconsTypes.sentFree,
    }
  }

  if (isMessagesOfMedia) {
    return {
      bgColor: '#A71B283D',
      tagColor: 'rgba(167, 27, 40, 0.50)',
      text: 'Sent',
      iconType: OverlayIconsTypes.sent,
    }
  }

  return null
}
